"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DOWNLOAD_QR_CODE = void 0;
const DOWNLOAD_QR_CODE = exports.DOWNLOAD_QR_CODE = 'download-qr-code';
